import React, { useEffect, useReducer, useRef } from 'react';
import { useDocumentViewerFiles } from './useDocumentViewerFiles';
import DocumentsViewerButton from './DocumentsViewerButton';
import { ClaimContext } from '../types';

interface UseDocumentsViewerProps {
  claim: ClaimContext;
  workflowStep: string;
}

export function useDocumentsViewer(props: UseDocumentsViewerProps) {
  const { claim, workflowStep } = props;

  const [isDocumentsViewerOpen, toggleDocumentsViewer] = useReducer((state: boolean) => !state, false);

  const documentViewerFiles = useDocumentViewerFiles(claim);

  const documentsViewerButtonElement = (
    <DocumentsViewerButton isViewerOpen={isDocumentsViewerOpen} onClick={toggleDocumentsViewer} />
  );

  const previousDocumentCount = useRef(documentViewerFiles.length);

  // biome-ignore lint/correctness/useExhaustiveDependencies: unknown
  useEffect(() => {
    const isNotDelete = documentViewerFiles.length > previousDocumentCount.current;

    const shouldOpenDocumentsViewer = !isDocumentsViewerOpen && documentViewerFiles.length > 0 && isNotDelete;

    if (shouldOpenDocumentsViewer) {
      toggleDocumentsViewer();
    }

    previousDocumentCount.current = documentViewerFiles.length;
  }, [workflowStep, documentViewerFiles]);

  return {
    documentsViewerButtonElement,
    documentViewerFiles,

    isDocumentsViewerOpen,
    toggleDocumentsViewer,
  };
}
